import React, { FunctionComponent, ReactNode, useMemo } from 'react';
import Client from '@lt/api';
import { apiContext } from './apiContext';
import { useGetPartnerKey } from '../constructorContext';
import { baseUrl, safetyPartnerKey } from '../../utils/api';

type Props = {
  children: ReactNode;
  apiDomain?: string;
};

export const ApiContextProvider: FunctionComponent<Props> = ({
  children,
  apiDomain,
}) => {
  const constructorKey = useGetPartnerKey();
  const apiKey = safetyPartnerKey || constructorKey;
  const apiBaseUrl = apiDomain || baseUrl || 'https://api.level.travel';

  const state = useMemo(() => {
    if (!apiKey) {
      return { api: undefined };
    }

    const client = new Client({
      key: apiKey,
      baseURL: apiBaseUrl,
    });
    return { api: client };
  }, [apiKey, apiBaseUrl]);

  if (!apiKey) {
    console.log('Не найден ключ партнера');
    return null;
  }

  return <apiContext.Provider value={state}>{children}</apiContext.Provider>;
};
